<template>
<w-sliding-popup ref="slidingPopup" type="common" title="즐겨찾기 추가" width="470px" :default-content="false" @close="onClose">
  <div slot="content" class="body-content-no-scroll" style="height:100%;">
    <el-form ref="form" :model="bookmarkInfo" label-position="top" :rules="rules">
      <el-form-item label="이름" prop="bookmarkName">
        <el-input type="textarea" v-model="bookmarkInfo.bookmarkName" placeholder="입력해 주세요."></el-input>
      </el-form-item>
      <el-form-item label="경로">
        <el-input type="textarea" v-model="bookmarkInfo.pathDesc" placeholder="입력해 주세요." disabled></el-input>
      </el-form-item>
    </el-form>
    <div class="mr-t20" style="height:calc(100% - 186px); width:100%; padding:5px 15px 15px 15px; border: 1px solid #dcdfe6">
      <el-scrollbar>
        <el-tree class="bookmark-tree edit tree-w-stroke" ref="tree" default-expand-all :data="treeData" :props="defaultProps" :node-key="defaultProps.treeKey" :expand-on-click-node="false" :filter-node-method="filterNode" highlight-current :allow-drop="allowDrop" @node-click="clickNode">
          <span class="el-tree-node__label" slot-scope="{ node, data }">
            <span class="group">{{data.label}}</span>
          </span>
        </el-tree>
      </el-scrollbar>
    </div>
  </div>
  <div slot="footer">
    <el-button class="mr-r4" type="solid" size="large" @click="saveBookmarkInfo">저장</el-button>
    <el-button size="large" @click="onClose">취소</el-button>
  </div>
</w-sliding-popup>
</template>

<script>
import { isNil } from 'lodash';
import TreeFilter from '@/mixins/tree/filter';
import BookmarkAPI from '@/api/frame/bookmark';
import WSearchField from '@/components/form/SearchField';
import { defaultProps } from '@/constants/tree';
import msgUtil from '@/utils/message';
import DragTreeMixin from '@/views/chart/components/tree/mixins/drag-tree';

export default {
  name: 'WAddBookmarkPopup',
  components: {
    WSearchField,
  },
  mixins: [TreeFilter, DragTreeMixin],
  props: { addTargetBookmark: Object },
  data() {
    return {
      targetBookmark: null,
      bookmarkInfo: {
        bookmarkName: null,
        pathDesc: null,
        path: null,
      },
      defaultProps,
      treeRef: 'tree',
      treeData: null,
      rules: {
        bookmarkName: {
          required: true,
          message: '필수 정보입니다.',
          trigger: 'blur',
        },
      },
    };
  },
  computed: {
    /**
     * 로그인한 계정 정보
     * @author yelim
     * @return {[type]} [description]
     */
    userInfo() {
      return this.$store.getters.userInfo;
    },
    /**
     * 현재 선택한 메뉴의 정보
     * @author yelim
     * @return {[type]} [description]
     */
    menuInfo() {
      const menuId = this.$store.getters.selectedMenu.menuId;
      const managetypeId = this.$store.getters.selectedMenu.managetypeId;
      return { menuId, managetypeId };
    },
    currnetPageInfo() {
      const bookmarkName = this.$store.getters.navigationPathLabel;
      const bookmarkPath = this.$route.path;
      return { bookmarkName, bookmarkPath };
    },
  },
  watch: {
    addTargetBookmark: {
      handler(bookmarkInfo) {
        if (!isNil(bookmarkInfo)) {
          this.bookmarkInfo = this.addTargetBookmark;
        }
      },
      immediate: true,
    }
  },
  methods: {
    open() {
      this.loadData();
      this.$refs.slidingPopup.open();
    },
    onClose() {
      this.targetBookmark = null;
      this.$refs.form.clearValidate();
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 즐겨찾기 그룹 트리를 조회한다.
     * @author yelim
     * @return {[type]} [description]
     */
    loadData() {
      BookmarkAPI.getBookmarkTree({ searchGroupFlag: true }).then((response) => {
        if (response.data.success) {
          this.treeData = response.data.data;
          this.$nextTick(() => {
            this.$refs.tree.setCurrentNode(this.treeData[0]);
            this.selectGroupId = null;
          });
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '즐겨찾기 목록', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '즐겨찾기 목록', false));
        throw new Error(e);
      });
    },
    /**
     * 선택한 즐겨찾기 그룹의 정보를 관리한다.
     * @author yelim
     * @return {[type]} [description]
     */
    clickNode(node) {
      this.selectGroupId = (node.subType === 'ROOT') ? null : node.groupId;
    },
    /**
     * 추가할 즐겨찾기 정보를 저장한다.
     * @author yelim
     * @return {[type]} [description]
     */
    saveBookmarkInfo() {
      const userId = this.userInfo.managerId;
      const params = {
        menuId: this.menuInfo.menuId,
        managetypeId: this.menuInfo.managetypeId,
        bookmarkName: this.bookmarkInfo.bookmarkName,
        bookmarkPath: this.bookmarkInfo.path,
        lastVisitDatetime: new Date(),
        managerId: userId,
        groupId: this.selectGroupId,
      };
      BookmarkAPI.setBookmarkInfo(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '즐겨찾기', true));
          this.$emit('reload');
          this.onClose();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '즐겨찾기', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.SAVE, '즐겨찾기', false));
        throw new Error(e);
      });
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/frame/components/popup/AddBookmarkPopup.vue